<!-- 填空题 -->
<template>
	<div class="blank" v-if="info.myAnswer">
		<div class="content" v-if="info">
			<div class="title fontSize14">
				【{{quesMap[info.type]}}】{{info.no?info.no:(Number(no)+1)}}、<span v-html="reformHtml(info.content)"></span>
			</div>
			<div class="txts" v-if="!readOnly">
				<input v-model="info.myAnswer[index]" placeholder="请输入" @input="change" v-for="(item,index) in info.myAnswer" :key="index"/>
			</div>
			<!-- 解析 -->
			<div class="analysisBox" v-if="readOnly">
				<div class="d-flex d-flex-middle" v-if="showAnswer">
					标准答案：
					<p v-for="(item,index) in info.blanks" :key="index">{{ item.value }}</p>
				</div>
				<div v-if="showAnswer && answerExpose && (info.ext||info.analysis)">答案解析：<span v-html="info.ext||info.analysis"></span></div>
				<div class="d-flex d-flex-middle">
					我的答案：
					<p v-for="(item,index) in info.myAnswer" :key="index">{{ item || '-' }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {quesMap} from '@/utils/enums'
	export default {
		name:"blank",
		props:{
			info:{},
			no:'',
			readOnly: false,
			showAnswer:{
				default: false
			},
			answerExpose:{
				default: false
			}
		},
		data() {
			return {
				quesMap,
			};
		},
		computed:{
			getMyAnswer() {
				var list = []
				this.info.myAnswer.map(v=>{
					list.push(v.value)
				})
				return list.join('`')
            }
		},
		methods:{
			reformHtml(html){
				var reg = new RegExp('\\[BlankArea\\d]','g');
				html = html.replace(reg, '____');
				const regex = new RegExp('<img', 'gi');
     			html= html.replace(regex, `<img style="max-width: 100%;"`);
				return html.replace(/<p.*?>/gi, "").replace(/<\/p.*?>/gi, "");
			},
			change(e){
				var data = {
					id: this.info.id,
					value: this.info.myAnswer
				}
				this.$emit('change',data)
			}
		}
	}
</script>

<style lang="scss">
.blank{
	font-size: 14px;
	p{
		margin: 0;
	}
	.content{
		.title{
			margin-bottom: 15px;
			line-height: 20px;
			// width: calc(100% - 160px);
			&.all{
				width: 100%;
			}
		}
		.txts{
			input{
				width: 100%;
				border: 1px solid #999;
				border-radius: 5px;
				height: 32px;
				line-height: 20px;
				margin-bottom: 15px;
				box-sizing: border-box;
				padding: 5px 10px;
				font-size: 14px;
			}
		}
	}
	.analysisBox{
		box-sizing: border-box;
		padding: 5px 10px;
		border-radius: 5px;
		background: #eee;
		margin: 10px 0;
		div{
			margin: 5px 0;
			word-break: break-all;
			p{
				max-width: calc(100% - 100px);
				max-height: 100px;
				overflow-y: auto;
				min-height: 30px;
				line-height: 30px;
				box-sizing: border-box;
				padding: 0 5px;
				background: #fff;
				margin-right: 10px;
				border-radius: 5px;
				min-width: 60px;
				word-break: break-all;
			}
		}
	}
}
</style>
